import { Preferences } from '@capacitor/preferences';
import { Network } from '@capacitor/network';
import { getLesson } from '../content/curriculum';

const KEY = 'ef365-offline-pack-v1';

export interface OfflinePack {
  version: 1;
  startDay: number;
  endDay: number;
  generatedAt: string;
  lessons: ReturnType<typeof getLesson>[];
}

export async function buildOfflinePack(day: number): Promise<OfflinePack> {
  const startDay = Math.max(1, Math.min(365, day));
  const endDay = Math.min(365, startDay + 6);
  const lessons = Array.from({ length: endDay - startDay + 1 }, (_, index) => getLesson(startDay + index));
  const pack: OfflinePack = { version: 1, startDay, endDay, generatedAt: new Date().toISOString(), lessons };
  await Preferences.set({ key: KEY, value: JSON.stringify(pack) });
  return pack;
}

export async function getOfflinePack(): Promise<OfflinePack | null> {
  const { value } = await Preferences.get({ key: KEY });
  if (!value) return null;
  try { return JSON.parse(value) as OfflinePack; } catch { return null; }
}

export async function ensureOfflinePack(day: number) {
  const current = await getOfflinePack();
  if (current && day >= current.startDay && day <= current.endDay) return current;
  return buildOfflinePack(day);
}

export async function offlineStatus(day: number) {
  const [network, pack] = await Promise.all([
    Network.getStatus().catch(() => ({ connected: navigator.onLine })),
    ensureOfflinePack(day),
  ]);
  return { connected: network.connected, pack };
}
